/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const Liferay = window.Liferay || {
    OAuth2: {
        getAuthorizeURL: () => '',
        getBuiltInRedirectURL: () => '',
        getIntrospectURL: () => '',
        getTokenURL: () => '',
        getUserAgentApplication: (_serviceName) => {}
    },
    OAuth2Client: {
        FromParameters: (_options) => {
            return {};
        },
        FromUserAgentApplication: (_userAgentApplicationId) => {
            return {};
        },
        fetch: (_url, _options = {}) => {}
    },
    ThemeDisplay: {
        isImpersonated: () => {
            return false;
        },
        getDoAsUserIdEncoded: () => {
            return '';
        },
        getCompanyGroupId: () => 0,
        getScopeGroupId: () => 0,
        getSiteGroupId: () => 0,
        isSignedIn: () => {
            return false;
        },
        getSessionId: () => {
            return '';
        }
    },
    authToken: '',
    Service: (_url, _options, _callback) => {}
};
